import React, { Component, useState } from "react";
import { Rating } from 'react-simple-star-rating'
import { Link, withRouter } from "react-router-dom";
import top_agent1 from "../../../assets/images/top_agent1.png";
import top_agent2 from "../../../assets/images/top_agent2.png";
import top_agent3 from "../../../assets/images/top_agent3.png";
import top_agent4 from "../../../assets/images/top_agent4.png";
import top_agent5 from "../../../assets/images/top_agent5.png";
import top_agent6 from "../../../assets/images/top_agent6.png";


const Agent_detail = () => {
    const [ratingValue, setRatingValue] = useState(0) // initial rating v
    const handleRating = (rate) => {
        setRatingValue(rate)
    }
    const handleReset = () => {
        setRatingValue(4)
    }

    return (
        <div>
            <div className="agent_area">
                <div className="inner_area">
                    <div className="heading_area">
                        <h4>Agents</h4>
                        <p>Lorem ipsum dolor sit amet, con sectetur adipiscing elit. Maecenas con sectetur
                            maximus est, vel tincidunt odio auctor nec. Nam sed sollicitudin sapien.</p>
                    </div>
                    <div className="row">
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div className="uni_detail_area">
                                <div className="agent_box">
                                    <div className="agent_inner_area">
                                        <div className="left_area">
                                            <div className="img_area">
                                                <img src={top_agent2} alt="" />
                                            </div>
                                        </div>
                                        <div className="right_area">
                                            <div className="top-area">
                                                <div className="left_area">
                                                    <h5>Cody Fisher</h5>
                                                </div>
                                                <div className="right-area">
                                                    <div className="rating_area">
                                                        <Rating
                                                            ratingValue={ratingValue}
                                                            showTooltip={true}
                                                            initialValue={3.8}
                                                            readonly
                                                            tooltipArray={["0.1", "0.2", "0.3", "0.4", "0.5"]}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="desc">
                                                Lorem ipsum sit dolor amet dor lorem sit. Lorem sit dolor.
                                            </div>
                                            <div className="location_area">
                                                <div className="location_left_area">
                                                    <i class="fas fa-map-marker-alt"></i>
                                                </div>
                                                <div className="location_right_area">
                                                    <p> Lorem ipsum sit, canada</p>
                                                </div>
                                            </div>
                                            <div className="success_area">
                                                <div className="success_left_area">
                                                    <i class="fal fa-check-circle"></i>
                                                </div>
                                                <div className="success_right_area">
                                                    <p> 90% Sucess Rate</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bottom_area">
                                        <p>Contact Now</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div className="uni_detail_area">
                                <div className="agent_box">
                                    <div className="agent_inner_area">
                                        <div className="left_area">
                                            <div className="img_area">
                                                <img src={top_agent1} alt="" />
                                            </div>
                                        </div>
                                        <div className="right_area">
                                            <div className="top-area">
                                                <div className="left_area">
                                                    <h5>Cody Fisher</h5>
                                                </div>
                                                <div className="right-area">
                                                    <div className="rating_area">
                                                        <Rating
                                                            ratingValue={ratingValue}
                                                            showTooltip={true}
                                                            initialValue={3.8}
                                                            readonly
                                                            tooltipArray={["0.1", "0.2", "0.3", "0.4", "0.5"]}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="desc">
                                                Lorem ipsum sit dolor amet dor lorem sit. Lorem sit dolor.
                                            </div>
                                            <div className="location_area">
                                                <div className="location_left_area">
                                                    <i class="fas fa-map-marker-alt"></i>
                                                </div>
                                                <div className="location_right_area">
                                                    <p> Lorem ipsum sit, canada</p>
                                                </div>
                                            </div>
                                            <div className="success_area">
                                                <div className="success_left_area">
                                                    <i class="fal fa-check-circle"></i>
                                                </div>
                                                <div className="success_right_area">
                                                    <p> 90% Sucess Rate</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bottom_area">
                                        <p>Contact Now</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div className="uni_detail_area">
                                <div className="agent_box">
                                    <div className="agent_inner_area">
                                        <div className="left_area">
                                            <div className="img_area">
                                                <img src={top_agent3} alt="" />
                                            </div>
                                        </div>
                                        <div className="right_area">
                                            <div className="top-area">
                                                <div className="left_area">
                                                    <h5>Cody Fisher</h5>
                                                </div>
                                                <div className="right-area">
                                                    <div className="rating_area">
                                                        <Rating
                                                            ratingValue={ratingValue}
                                                            showTooltip={true}
                                                            initialValue={3.8}
                                                            readonly
                                                            tooltipArray={["0.1", "0.2", "0.3", "0.4", "0.5"]}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="desc">
                                                Lorem ipsum sit dolor amet dor lorem sit. Lorem sit dolor.
                                            </div>
                                            <div className="location_area">
                                                <div className="location_left_area">
                                                    <i class="fas fa-map-marker-alt"></i>
                                                </div>
                                                <div className="location_right_area">
                                                    <p> Lorem ipsum sit, canada</p>
                                                </div>
                                            </div>
                                            <div className="success_area">
                                                <div className="success_left_area">
                                                    <i class="fal fa-check-circle"></i>
                                                </div>
                                                <div className="success_right_area">
                                                    <p> 90% Sucess Rate</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bottom_area">
                                        <p>Contact Now</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div className="uni_detail_area">
                                <div className="agent_box">
                                    <div className="agent_inner_area">
                                        <div className="left_area">
                                            <div className="img_area">
                                                <img src={top_agent4} alt="" />
                                            </div>
                                        </div>
                                        <div className="right_area">
                                            <div className="top-area">
                                                <div className="left_area">
                                                    <h5>Cody Fisher</h5>
                                                </div>
                                                <div className="right-area">
                                                    <div className="rating_area">
                                                        <Rating
                                                            ratingValue={ratingValue}
                                                            showTooltip={true}
                                                            initialValue={3.8}
                                                            readonly
                                                            tooltipArray={["0.1", "0.2", "0.3", "0.4", "0.5"]}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="desc">
                                                Lorem ipsum sit dolor amet dor lorem sit. Lorem sit dolor.
                                            </div>
                                            <div className="location_area">
                                                <div className="location_left_area">
                                                    <i class="fas fa-map-marker-alt"></i>
                                                </div>
                                                <div className="location_right_area">
                                                    <p> Lorem ipsum sit, canada</p>
                                                </div>
                                            </div>
                                            <div className="success_area">
                                                <div className="success_left_area">
                                                    <i class="fal fa-check-circle"></i>
                                                </div>
                                                <div className="success_right_area">
                                                    <p> 90% Sucess Rate</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bottom_area">
                                        <p>Contact Now</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div className="uni_detail_area">
                                <div className="agent_box">
                                    <div className="agent_inner_area">
                                        <div className="left_area">
                                            <div className="img_area">
                                                <img src={top_agent5} alt="" />
                                            </div>
                                        </div>
                                        <div className="right_area">
                                            <div className="top-area">
                                                <div className="left_area">
                                                    <h5>Cody Fisher</h5>
                                                </div>
                                                <div className="right-area">
                                                    <div className="rating_area">
                                                        <Rating
                                                            ratingValue={ratingValue}
                                                            showTooltip={true}
                                                            initialValue={3.8}
                                                            readonly
                                                            tooltipArray={["0.1", "0.2", "0.3", "0.4", "0.5"]}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="desc">
                                                Lorem ipsum sit dolor amet dor lorem sit. Lorem sit dolor.
                                            </div>
                                            <div className="location_area">
                                                <div className="location_left_area">
                                                    <i class="fas fa-map-marker-alt"></i>
                                                </div>
                                                <div className="location_right_area">
                                                    <p> Lorem ipsum sit, canada</p>
                                                </div>
                                            </div>
                                            <div className="success_area">
                                                <div className="success_left_area">
                                                    <i class="fal fa-check-circle"></i>
                                                </div>
                                                <div className="success_right_area">
                                                    <p> 90% Sucess Rate</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bottom_area">
                                        <p>Contact Now</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                            <div className="uni_detail_area">
                                <div className="agent_box">
                                    <div className="agent_inner_area">
                                        <div className="left_area">
                                            <div className="img_area">
                                                <img src={top_agent6} alt="" />
                                            </div>
                                        </div>
                                        <div className="right_area">
                                            <div className="top-area">
                                                <div className="left_area">
                                                    <h5>Cody Fisher</h5>
                                                </div>
                                                <div className="right-area">
                                                    <div className="rating_area">
                                                        <Rating
                                                            ratingValue={ratingValue}
                                                            showTooltip={true}
                                                            initialValue={3.8}
                                                            readonly
                                                            tooltipArray={["0.1", "0.2", "0.3", "0.4", "0.5"]}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="desc">
                                                Lorem ipsum sit dolor amet dor lorem sit. Lorem sit dolor.
                                            </div>
                                            <div className="location_area">
                                                <div className="location_left_area">
                                                    <i class="fas fa-map-marker-alt"></i>
                                                </div>
                                                <div className="location_right_area">
                                                    <p> Lorem ipsum sit, canada</p>
                                                </div>
                                            </div>
                                            <div className="success_area">
                                                <div className="success_left_area">
                                                    <i class="fal fa-check-circle"></i>
                                                </div>
                                                <div className="success_right_area">
                                                    <p> 90% Sucess Rate</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bottom_area">
                                        <p>Contact Now</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="btn_area">
                        <button className="btn-primary-1" >+ View More</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Agent_detail;


